import React from 'react';
import NewsIconWrapper from './NewsIconWrapper';

export default function ChangingConditions(props) {
  return (
    <NewsIconWrapper {...props}>
      <circle cx="16" cy="16" r="16" fill="#FAD6B7"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M16 13V10C12.69 10 10 12.69 10 16C10 17.01 10.25 17.97 10.7 18.8L9.24 20.26C8.46 19.03 8 17.57 8 16C8 11.58 11.58 8 16 8V5L20 9L16 13ZM21.3 13.2L22.76 11.74C23.54 12.97 24 14.43 24 16C24 20.42 20.42 24 16 24V27L12 23L16 19V22C19.31 22 22 19.31 22 16C22 14.99 21.74 14.04 21.3 13.2Z" fill="black" fillOpacity="0.54"/>
    </NewsIconWrapper>
  );
}
